module.exports = __webpack_public_path__ + "img/IMAGE11.3eec08ba.jpg";